import { BaseApi } from './api';

const configHeaderJSON = { headers: { 'content-type': 'application/json' } };

export const getService = (path: string, params = {}) => {
  return BaseApi.get(path, params);
};

export const postService = (path: string, body = {}, headers = configHeaderJSON) => {
  return BaseApi.post(path, body, headers);
};

export const putService = (path: string, body = {}, headers = configHeaderJSON) => {
  return BaseApi.put(path, body, headers);
};

export const deleteService = (path: string, body = {}) => {
  return BaseApi.delete(path, body);
};

export const patchService = (path: string, body = {}, headers = configHeaderJSON) => {
  return BaseApi.patch(path, body, headers);
};
